export * from "/srv/app/node_modules/@datadog/browser-rum/esm/entries/main.js"